import { ReactNode } from 'react'
import { NotificationHandler } from '../components/provider/NotificationProvider'

let notificationRef: NotificationHandler | null = null

// connect this ref to the notification provider in index.tsx
export const setNotificationRef = (ref: NotificationHandler | null) => {
  notificationRef = ref
}

interface NotificationProps {
  messageToDisplay?: ReactNode
  duration?: number
  closable?: boolean
}

const notificationSuccess = (notification: NotificationProps) => {
  notificationRef?.addNotification({
    type: 'success',
    content: notification.messageToDisplay,
    duration: notification.duration,
    closable: notification.closable,
  })
}

const notificationError = (notification: NotificationProps) => {
  notificationRef?.addNotification({
    type: 'error',
    content: notification.messageToDisplay,
    duration: notification.duration,
    closable: notification.closable,
  })
}

const notificationWarning = (notification: NotificationProps) => {
  notificationRef?.addNotification({
    type: 'warning',
    content: notification.messageToDisplay,
    duration: notification.duration,
    closable: notification.closable,
  })
}

const notificationInfo = (notification: NotificationProps) => {
  notificationRef?.addNotification({
    type: 'info',
    content: notification.messageToDisplay,
    duration: notification.duration,
    closable: notification.closable,
  })
}

export const notificationService = {
  notificationError,
  notificationSuccess,
  notificationWarning,
  notificationInfo,
  setNotificationRef,
}

export default notificationService
